import { DEFAULT_CHAT_WITH_FEEDBACK_PROMPT } from '@modules/chatWithFeedback/constants';
import {
  useIsCWFPromptOptionsEnabled,
  useIsSearchToFeedEnabled,
} from '@modules/common/hooks';
import { useIsChatWithFeedbackEnabled } from '@modules/feed/hooks';
import { Alert, Box, Divider, Link, Stack, Typography } from '@mui/material';
import { SEARCH_SUBSCRIPTION_HELPCENTER_URL } from './constants';
import { useIsReportingForCWFEnabled } from './hooks';

interface SearchSubscribeDrawerContentHeaderProps {
  prompt: string;
}

export const SearchSubscribeDrawerContentHeader = ({
  prompt,
}: SearchSubscribeDrawerContentHeaderProps) => {
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  const isChatWithFeedbackEnabled = useIsChatWithFeedbackEnabled();

  const isReportingForCWFEnabled = useIsReportingForCWFEnabled();

  const isCWFPromptOptionsEnabled = useIsCWFPromptOptionsEnabled();

  const shouldShowPrompt = isCWFPromptOptionsEnabled ? !!prompt : true;

  if (isChatWithFeedbackEnabled && isReportingForCWFEnabled) {
    return (
      <Stack spacing={1}>
        <Alert severity="info">
          We'll deliver a response to the below prompt based on new feedback.
          You can edit the prompt by clicking on "Ask / Summarize Feed".{' '}
          <Link
            href={SEARCH_SUBSCRIPTION_HELPCENTER_URL}
            target="_blank"
            rel="noreferrer"
          >
            Learn More
          </Link>
        </Alert>
        {shouldShowPrompt && (
          <Stack direction="row" spacing={1} p={2}>
            <Box>Prompt:</Box>
            <Box>{prompt || DEFAULT_CHAT_WITH_FEEDBACK_PROMPT} </Box>
          </Stack>
        )}
        <Divider />
      </Stack>
    );
  }

  return (
    <Box p={2}>
      <Typography color="text.secondary" component="span" variant="body2">
        Subscribing to a saved {isSearchToFeedEnabled ? 'Feed' : 'Search'} will
        deliver a summary of your customer's voice, along with a relevant
        feedback records at your prescribed cadence.{' '}
      </Typography>
      <Link
        variant="body2"
        href={SEARCH_SUBSCRIPTION_HELPCENTER_URL}
        target="_blank"
        rel="noreferrer"
      >
        Learn More
      </Link>
    </Box>
  );
};
